import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { TableColumn } from '@app/interfaces';

const standaloneImports = [MatTableModule, CommonModule];

@Component({
    selector: 'table-basic',
    styleUrls: ['./table-basic.component.less'],
    standalone: true,
    imports: [...standaloneImports],
    template: `
		<div class="table-basic-container" [class]="containerClass">
			<table mat-table [dataSource]="dataSource" [attr.aria-label]="ariaLabel || 'Data Table'">
				<ng-container [matColumnDef]="column.key" *ngFor="let column of columns; trackBy: trackByColumnKey">
					<th mat-header-cell *matHeaderCellDef [class]="column.headerClass">
						{{ column.header }}
					</th>
					<td mat-cell *matCellDef="let row" [class]="column.cellClass">
						{{ renderTextCell({ column: column, row: row }) }}
					</td>
				</ng-container>
				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
			</table>
			<div *ngIf="showEmptyState && (!dataSource || dataSource.length === 0)" class="empty-state">
				<p>{{ emptyStateText || 'No data available' }}</p>
			</div>
		</div>    
    `,
})
export class TableBasicComponent<T = any> implements OnInit {
    @Input() dataSource: T[] = [];
    @Input() columns: TableColumn[] = [];
    @Input() containerClass?: string;
    @Input() ariaLabel?: string;
    @Input() showEmptyState: boolean = true;
    @Input() emptyStateText?: string;

    displayedColumns: any[] = [];

    ngOnInit(): void {
        this.updateDisplayedColumns();
    }

    ngOnChanges(): void {
        this.updateDisplayedColumns();
    }

    public renderTextCell({ column, row }): string {
        if (typeof column.transform === 'function') {
            return column.transform({ row, value: row[column.key], key: column.key });
        }
        if (row[column.key] !== null && row[column.key] !== undefined) {
            return String(row[column.key]);
        }
        return '';
    }

    public trackByColumnKey(index: number, column: TableColumn): string {
        return String(column.key);
    }

    private updateDisplayedColumns(): void {
        this.displayedColumns = this.columns
            .filter(column => !column.hidden)
            .map(column => column.key);
    }
}